import React, { useState, useRef, useEffect } from "react";
import "../../style/admin/NewRate.css";
import { createCommissionSetting } from "../../utils/api";

export default function NewRate({ onClose }) {
  const [rate, setRate] = useState("");
  const [lastRate] = useState(0.5);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("percent");
  const [minDeposit, setMinDeposit] = useState(10);
  const [isActive, setIsActive] = useState(false);
  const modalRef = useRef(null);

  // Handler untuk klik di luar modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleChange = (e) => setRate(e.target.value);

  const handleSave = async () => {
    if (type === "percent") {
      if (!rate || parseFloat(rate) > 100 || parseFloat(rate) <= 0) {
        alert("Percent rate must be between 0.01% and 100%");
        return;
      }
    } else {
      if (!rate || parseFloat(rate) >= 5 || parseFloat(rate) <= 0) {
        alert("Flat rate must be between $0.01 and $4.99");
        return;
      }
    }

    try {
      setLoading(true);

      const data = {
        name: `setting_${Date.now()}`,
        commission_type: type,
        commission_value: parseFloat(rate),
        min_deposit: parseFloat(minDeposit),
        is_active: isActive,
      };

      const res = await createCommissionSetting(data);

      alert(res.message || "New referral setting created successfully");
      onClose();
    } catch (err) {
      alert(`Failed to save: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newrate-modal-overlay" onClick={onClose}>
      <div 
        className="newrate-container" 
        ref={modalRef}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header dengan judul dan tombol close */}
        <div className="newrate-header">
          <h2 className="newrate-title">New Rate</h2>
          <button className="newrate-close-btn" onClick={onClose} title="Close">
            ×
          </button>
        </div>

        {/* Last Rate Box */}
        <div className="last-rate-box">
          <p className="last-rate-label">Last Rate</p>
          <p className="last-rate-value">${lastRate}</p>
        </div>

        {/* Form Content */}
        <div className="newrate-content">
          <div className="input-group">
            <label className="input-label">
              <span className="required-star">*</span> Commission Type
            </label>
            <select 
              value={type} 
              onChange={(e) => setType(e.target.value)}
              className="form-select"
            >
              <option value="percent">Percent (%)</option>
              <option value="flat">Flat ($)</option>
            </select>
          </div>

          <div className="input-group">
            <label className="input-label">
              <span className="required-star">*</span> New Rate
            </label>
            <div className="input-wrapper">
              {type === "flat" && <span className="currency-symbol">$</span>}
              <input
                type="number"
                placeholder={type === "percent" ? "e.g 5.0" : "e.g 1.0"}
                value={rate}
                onChange={handleChange}
                min="0.01"
                max={type === "percent" ? "100" : "4.99"}
                step="0.01"
                className="form-input"
              />
              {type === "percent" && <span className="currency-symbol">%</span>}
            </div>
            <small className="input-hint">
              {type === "percent"
                ? "Input rate between 0.01% and 100%"
                : "Input rate between $0.01 and $4.99"}
            </small>
          </div>

          <div className="input-group">
            <label className="input-label">
              <span className="required-star">*</span> Minimum Deposit
            </label>
            <div className="input-wrapper">
              <span className="currency-symbol">$</span>
              <input
                type="number"
                value={minDeposit}
                onChange={(e) => setMinDeposit(Number(e.target.value))}
                min="1"
                step="1"
                className="form-input"
              />
            </div>
          </div>

          <div className="checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                className="checkbox-input"
              />
              <span className="checkbox-text">Set as Active</span>
            </label>
          </div>
        </div>

        {/* Button Group */}
        <div className="button-group-NewRate">
          <button className="btn-back" onClick={onClose} disabled={loading}>
            Back
          </button>
          <button
            className="btn-save-newrate"
            disabled={!rate || loading}
            onClick={handleSave}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}